import 'semantic-ui-css/semantic.min.css';
import {
  Container,
  Grid,
  Header,
  List,
  Segment,
} from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import ContactModal from "../../components/Contact";
import {useEffect, useState} from "react";

const Footer = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const resizeListener = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    }
  }, []);


  const mobile = screenWidth <= 768;

  return (
<Segment vertical style={{
  padding: '5em 0em'
}}>
  <Container style={{maxWidth: '60%'}} >
    <Grid divided inverted centered >
      <Grid.Row>
        <Grid.Column centered width={mobile ? 1 : 3}/>
        <Grid.Column centered width={5}>
          <Header as='h4' content='Manouk van Egmond' />
        </Grid.Column>
        <Grid.Column width={5}>
          <Header as='h4' >Mijn werk</Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column centered width={mobile ? 1 : 3}/>
        <Grid.Column width={5}>
          <List link >
            <List.Item as={Link} to='/achtergrond' name=''>Over mij</List.Item>
            <List.Item><ContactModal /></List.Item>
          </List>
        </Grid.Column>
        <Grid.Column width={5}>
          <List link>
            <List.Item as={Link} to='/' name=''>Home</List.Item>
            <List.Item as={Link} to='/boeken' name=''>Boeken</List.Item>
            <List.Item as={Link} to='/stukken' name=''>Stukken</List.Item>
            <List.Item as={Link} to='/eindredactie' name=''>Eindredactie</List.Item>
          </List>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
</Segment>
);
}

export default Footer
